import Smart from 'hocs/smart';
import UserInvitation from './userInvitation-view';

export default Smart(
  UserInvitation,
  state => ({
    user: state.session.user,
  }),
  ac => ({
    displaySnackbar: ac.app.displaySnackbar,
  })
);
